import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p>to understand what is involved in setting achievable goals
                                                and how to strategically plan for the long-term to avoid
                                                falling foul of biases.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>STRATEGIC LONG-TERM GOAL SETTING
                                            </div>

                                            <p>What about two years from now, or ﬁve? Ideas are all very
                                                well but making them happen is the thing. And then, how
                                                realistic is your idea, anyway?
                                                What happens if you kick off and then, eighteen months later
                                                it doesn’t look so smart because, these days, the business
                                                environment, technology and
                                                all that seems to change from one quarter to the next – it’s
                                                like being at sea, trying to sight land through a
                                                kaleidoscope.</p>
                                            <p>Whether you’re planning a long-term project, re-orientating a
                                                department or considering some diversiﬁcation, it’s
                                                about...</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <p>‘Exploring the overarching objectives of the vision and
                                                    translating these into clear, tangible actions’</p>
                                            </div>
                                            <p>...and contingency planning, in case it gets choppy.</p>
                                            <p>There are so many books and articles on goal setting, but few
                                                of them give the basic requirements for a reasonable chance
                                                of success. So, even if
                                                some of it seems simplistic, we’ll give you a better idea of
                                                the kind of thing you need to include in your long-term
                                                planning and some practical techniques.</p>
                                            <p>Now, developing a concept and turning it into a strategy can
                                                seem like a daunting task. In theory you would probably want
                                                to have weeks or even months
                                                to sort out how you will build your vision. In practice this
                                                is not always realistic; however there are some
                                                straightforward steps that are useful to
                                                remember which can help to make it an easier and more
                                                enjoyable process.</p>
                                            <p>To start, we’ve developed a simple model of the key features
                                                of developing and managing strategic, long-term goals
                                                below.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>V-SPORT – CREATE YOUR STRATEGY
                                            </div>
                                            <p>The core elements of strategic goal setting are outlined
                                                below :</p>
                                            <div className="desktop">
                                                <table className="ilead_v_sport" width="70%" cellSpacing="0"
                                                       cellPadding="0" border="0">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="10%" align="left"
                                                            style={{paddingLeft: '10px'}}>Area
                                                        </th>
                                                        <th className="green_curve1" align="left"
                                                            style={{paddingLeft: '10px'}}>Description
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="">
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">V</span>
                                                        </td>
                                                        <td className="" valign="top">
                                                            <span className="greensubtitle4">Vision</span>
                                                            This is the strategy's focus. Ideally it should
                                                            be in line with the organisation's ethos and
                                                            complement overall goals and objectives.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">S</span>
                                                        </td>
                                                        <td>
                                                                        <span
                                                                            className="greensubtitle4">Stakeholders</span>
                                                            Identify key customers, stakeholders and other
                                                            appropriate parties to ensure their support.
                                                            Keep them informed at each stage to maintain
                                                            interest and commitment.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="">
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">P</span>
                                                        </td>
                                                        <td className="" valign="top">
                                                                        <span
                                                                            className="greensubtitle4">Priorities</span>
                                                            Prioritise what's essential to the strategy's
                                                            eventual success - important once it's underway
                                                            and time and resources are pressured.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">O</span>
                                                        </td>
                                                        <td>
                                                                        <span
                                                                            className="greensubtitle4">Opportunities</span>
                                                            Keep everyone involved aware of the benefits
                                                            being worked towards to help maintain momentum.
                                                            Raise awareness, too, of smaller benefits
                                                            resulting from the process itself - new skills
                                                            training, opportunity for employees, increased
                                                            awareness of competitor activity, etc.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="">
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">R</span>
                                                        </td>
                                                        <td className="" valign="top">
                                                            <span className="greensubtitle4">Risks</span>
                                                            Take time to explore actual and potential
                                                            de-railers and prepare ways of avoiding or
                                                            managing them effectively.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="rw-last">
                                                                        <span
                                                                            className="greentxt_bigfont vstrategy_bgfont">T</span>
                                                        </td>
                                                        <td className="rw-last1">
                                                                        <span
                                                                            className="greensubtitle4">Timelines</span>
                                                            Allow your strategy to be sufficiently flexible
                                                            to accommodate changes within or outside the
                                                            organisation. It is important to consider the
                                                            current situation and future changes.
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile">
                                                <div className="mobile-ilead-thought">
                                                    <table className="ilead_v_sport" width="100%"
                                                           cellSpacing="0" cellPadding="0" border="0">
                                                        <tbody>
                                                        <tr>
                                                            <th className="green_curve" width="10%"
                                                                align="left"
                                                                style={{paddingLeft: '10px'}}>Area
                                                            </th>
                                                            <th className="green_curve1" align="left"
                                                                style={{paddingLeft: '10px'}}>Description
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <td className="">
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">V</span>
                                                            </td>
                                                            <td className="" valign="top">
                                                                            <span
                                                                                className="greensubtitle4">Vision</span>
                                                                This is the strategy's focus. Ideally it
                                                                should be in line with the organisation's
                                                                ethos and complement overall goals and
                                                                objectives.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">S</span>
                                                            </td>
                                                            <td>
                                                                            <span
                                                                                className="greensubtitle4">Stakeholders</span>
                                                                Identify key customers, stakeholders and
                                                                other appropriate parties to ensure their
                                                                support. Keep them informed at each stage to
                                                                maintain interest and commitment.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="">
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">P</span>
                                                            </td>
                                                            <td className="" valign="top">
                                                                            <span
                                                                                className="greensubtitle4">Priorities</span>
                                                                Prioritise what's essential to the
                                                                strategy's eventual success - important once
                                                                it's underway and time and resources are
                                                                pressured.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">O</span>
                                                            </td>
                                                            <td>
                                                                            <span
                                                                                className="greensubtitle4">Opportunities</span>
                                                                Keep everyone involved aware of the benefits
                                                                being worked towards to help maintain
                                                                momentum. Raise awareness, too, of smaller
                                                                benefits resulting from the process itself -
                                                                new skills training, opportunity for
                                                                employees, increased awareness of competitor
                                                                activity, etc.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="">
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">R</span>
                                                            </td>
                                                            <td className="" valign="top">
                                                                            <span
                                                                                className="greensubtitle4">Risks</span>
                                                                Take time to explore actual and potential
                                                                de-railers and prepare ways of avoiding or
                                                                managing them effectively.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="rw-last">
                                                                            <span
                                                                                className="greentxt_bigfont vstrategy_bgfont">T</span>
                                                            </td>
                                                            <td className="rw-last1">
                                                                            <span
                                                                                className="greensubtitle4">Timelines</span>
                                                                Allow your strategy to be sufficiently
                                                                flexible to accommodate changes within or
                                                                outside the organisation. It is important to
                                                                consider the current situation and future
                                                                changes.
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <p style={{paddingTop:'20px'}}>The next section examines each of
                                                these aspects in more detail.</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}